import React from "react";
import { useNavigate } from "react-router-dom";

const DataNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
      <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
        Oops! Data not found
      </h2>
      <p className="text-gray-600 mb-6 max-w-md">
        The course or student information you're looking for couldn't be loaded.
        It may have been moved or deleted.
      </p>
      <button
        onClick={() => navigate("/dashboard")}
        className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg shadow-md transition-all duration-300"
      >
        Go to Dashboard
      </button>
    </div>
  );
};

export default DataNotFound;
